export default theme => ({
  root: {
    color: `${theme.palette.text.primary}b3`, // alpha 0.7
    '&.readOnly$focused': {
      color: `${theme.palette.text.primary}b3`
    }
  }
});
